<template>
    <v-card flat fill-height style="height:100%;">
        <!--{{vesselData}}-->
        <v-card-title  primary class="title" style="height:5%;">Vessel Info</v-card-title>
        <v-card-actions fill-height style="height:95%;">  
            <v-container fluid fill-height grid-list-md style="padding:5px;">
                <v-layout fill-height column>
                    <v-flex d-flex md7>
                        <v-layout column fill-height>
                            <v-layout v-for="item in vesselData" v-if="item" :key="item" row>
                                <v-flex md7 v-if="item.label" d-flex>{{item.label}}: </v-flex>
                                <v-flex md5 v-if="item.valuePort" style="text-align: right">
                                    {{item.valuePort}} (port) {{item.unit}}
                                    <br>
                                    {{item.valueStbd}} (stbd) {{item.unit}}
                                </v-flex>
                                <v-flex md5 v-else-if="item.value == -1000" style="text-align: right">- {{item.unit}}</v-flex>
                                <v-flex md5 v-else-if="item.format != null" style="text-align: right">{{item.value.toFixed(item.format)}} {{item.unit}}</v-flex>
                                <v-flex md5 v-else-if="item.value" style="text-align: right">{{item.value}} {{item.unit}}</v-flex>
                            </v-layout>
                        </v-layout>
                    </v-flex>
                    <v-flex d-flex md5>
                        <Map v-if="vesselData['route']" v-bind:points="vesselData['points']" v-bind:route="vesselData['route']" v-bind:zoom="4"/>
                    </v-flex>                   
                </v-layout>
            </v-container>
        </v-card-actions>
    </v-card>
</template>

<script>
    import Map from './Map'

    export default {
        name: "DashboardCard",
        components: {
            Map
        },
        props: {
            vesselData:Object
        },
        data: function () {
            return { 
                parameters:['ME_Torque_perc','ME_Power_perc','ensp','STW','SOG','Slip_STW','Slip_SOG','COG','Wind_Speed','Wind_direction_relative','Water_Depth','Rudder_angle']
            }
        },
        methods: {
        },
        mounted() {

        }, 
        watch: {
        }
    }
</script>

<style scoped>
</style>


